import React from 'react';

import Tooltip from 'CommonComponents/Tooltip';

import ExpensePackIcon from 'Assets/icons/expense-pack.svg';
import ExpenseTemplateIcon from 'Assets/icons/expense-template.svg';
import FolderIcon from 'Assets/icons/folder.svg';

/**
 * IB-875 — Leading structured-line-type indicator for the R&E Name column.
 *
 * Mirrors the icons in the persistent legend (RETypeIconLegend). A null / plain
 * simple-budget-line deliberately renders nothing.
 */
const TYPES = {
    et: { Icon: ExpenseTemplateIcon, label: 'Expense Template' },
    ep: { Icon: ExpensePackIcon, label: 'Expense Pack' },
    project: { Icon: FolderIcon, label: 'Project' },
};

export default function LineTypeIcon({ lineType }) {
    const entry = TYPES[lineType];
    if (!entry) return null;

    const { Icon, label } = entry;

    return (
        <Tooltip tooltipType="text" placement="top" tooltipContent={$t(label)}>
            <span className="tw-inline-flex tw-items-center">
                <Icon className="tw-w-3.5 tw-h-3.5 tw-shrink-0 tw-text-charcoal-75" />
            </span>
        </Tooltip>
    );
}
